const { LICENSE_TIERS } = require('../views/shared.constants');

// Recognized tier labels, verbatim — everything LICENSE_TIERS offers as a
// filter except the pseudo-tier 'None', which means "no license".
const TIER_LABELS = LICENSE_TIERS.filter(label => label !== 'None');

exports.parseLicenses = function parseLicenses(raw) {
  if (!raw || raw === '-') return { tiers: [], practiceAreas: [] };
  const parts = (typeof raw === 'string' ? raw.split(',') : Array.isArray(raw) ? raw : [])
    .map(v => String(v).trim())
    .filter(Boolean);
  const tierParts = parts.filter(p => TIER_LABELS.includes(p));
  const practiceAreas = [...new Set(parts.filter(p => !tierParts.includes(p)).filter(Boolean))];
  return { tiers: tierParts, practiceAreas };
};

exports.splitDateTime = function splitDateTime(str) {
  if (!str) return { date: '—', time: '' };
  const s = String(str);
  const idx = s.indexOf(' ');
  if (idx === -1) return { date: s, time: '' };
  return { date: s.substring(0, idx), time: s.substring(idx + 1) };
};

// Cryptographically-random integer in [0, max), falling back to Math.random
// where window.crypto is unavailable (older jsdom / non-browser contexts).
function randomInt(max) {
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    const arr = new Uint32Array(1);
    window.crypto.getRandomValues(arr);
    return arr[0] % max;
  }
  return Math.floor(Math.random() * max);
}

// Generates a strong password guaranteed to satisfy the server rules
// (min 8, ≥1 upper, ≥1 lower) plus a digit and symbol. Ambiguous glyphs
// (0/O, 1/l/I) are excluded so it's safe to read out over a support call.
exports.generateStrongPassword = function generateStrongPassword(length = 16) {
  const upper   = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const lower   = 'abcdefghijkmnopqrstuvwxyz';
  const digits  = '23456789';
  const symbols = '!@#$%^&*?-_=+';
  const all = upper + lower + digits + symbols;

  const pick = set => set[randomInt(set.length)];
  const size = Math.max(length, 8);

  // seed one of each required class, then fill the rest from the full pool
  const chars = [pick(upper), pick(lower), pick(digits), pick(symbols)];
  while (chars.length < size) chars.push(pick(all));

  // Fisher–Yates shuffle so the seeded classes aren't always in front
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomInt(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join('');
};

exports.convertToLocalTime = (utcDate) => {
  if (!utcDate) return '';
  const date = new Date(utcDate);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // Format as YYYY-MM-DD HH:mm:ss
};
